import React from 'react';
import Layout from '../../components/UI/Layout/Layout'
import List from '../../components/Entity/Dealers/List/List';

const DealersPage = () => {
  return <Layout title={'დილერები'} fullwidth={0}>
       <List></List>
    </Layout>;
}

export default DealersPage;
